import { ArrowRight, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/App";
import { useLang } from "@/i18n/LangContext";
import { InteractiveInk } from "@/components/InteractiveInk";

const HERO_IMG = "https://images.unsplash.com/photo-1577915332909-39e7c140bf3c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const HeroSection = ({ settings }) => {
  const { user } = useAuth();
  const { t } = useLang();
  const instagramUrl = settings?.instagram_url || "https://www.instagram.com/purple_ink_studio/";

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden noise-overlay">
      <InteractiveInk src={HERO_IMG} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/60 via-[#050505]/75 to-[#050505]" />
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 30% 40%, rgba(217, 70, 239, 0.08), transparent 60%)" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-24 pb-16">
        <div className="max-w-3xl">
          <p className="text-xs tracking-[0.3em] uppercase font-bold text-purple-400 mb-6 animate-fade-in-up opacity-0 stagger-1" style={{ fontFamily: "'Cinzel Decorative', serif" }} data-testid="hero-subtitle">
            {t("hero_subtitle")}
          </p>
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tighter uppercase leading-[0.9] mb-8 animate-fade-in-up opacity-0 stagger-2" data-testid="hero-title">
            Purple{" "}
            <span className="text-purple-500 neon-text-purple animate-neon-flicker">INK</span>
          </h1>
          <p className="text-base md:text-lg text-neutral-400 leading-relaxed max-w-xl mb-12 animate-fade-in-up opacity-0 stagger-3" data-testid="hero-description">
            {t("hero_tagline")}
          </p>
          <div className="flex flex-wrap gap-4 animate-fade-in-up opacity-0 stagger-4">
            <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-purple-600 hover:bg-purple-500 text-white font-bold py-4 px-8 border border-purple-400 shadow-[0_0_20px_rgba(192,38,211,0.3)] hover:shadow-[0_0_30px_rgba(192,38,211,0.6)] transition-all duration-300 uppercase tracking-widest text-sm group" data-testid="hero-book-btn">
              {t("hero_book")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
            </a>
            <a href="#gallery" className="inline-flex items-center gap-3 bg-transparent text-neutral-300 hover:text-white hover:bg-white/5 border border-white/10 hover:border-white/20 py-4 px-8 transition-all duration-300 uppercase tracking-widest text-sm" data-testid="hero-gallery-btn">
              {t("hero_view")}
            </a>
            {!user && (
              <Link to="/login" className="inline-flex items-center gap-3 bg-transparent text-purple-300 hover:text-white hover:bg-purple-600/20 border border-purple-500/30 hover:border-purple-500/60 py-4 px-8 transition-all duration-300 uppercase tracking-widest text-sm group" data-testid="hero-login-btn">
                <LogIn className="w-4 h-4" />
                {t("hero_login")}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
